import { useSectors } from '../../../hooks/useSectors';

interface SectorPillProps {
  sectorId: string | null;
}

export function SectorPill({ sectorId }: SectorPillProps) {
  const { sectors } = useSectors();

  if (!sectorId) return null;

  const sector = sectors.find((s) => s.id === sectorId);
  if (!sector) return null;

  return (
    <span className="rounded-full bg-indigo-100 px-2 py-0.5 text-xs text-indigo-800">
      {sector.label}
    </span>
  );
}
